export const applications = {
    PDF_MERGER: 'PDF Merger',
    PDF_SPLITTER: 'PDF Splitter',
    PDF_VIEWER: 'PDF Viewer',
}